import auth from '@udacity/ureact-hoth';

import { getMentorApi } from 'app/mentor/queries/enhanced';
import { eligibleProjectLanguagesFromApproved } from 'app/helpers/project-language-helper';

// For sagas and memoized queue selectors, which cannot call query hooks.
export const getEligibleProjectLanguages = (state) => {
  const uid = auth.getCurrentUserId() || '';
  const { data } = getMentorApi.endpoints.MentorDash_MentorQuery.select({ uid })(state);
  return eligibleProjectLanguagesFromApproved(data?.mentor?.approved_languages);
};
